import styled from 'styled-components'

import { Container, Image, Header, Button, Icon, Card, Grid, TableRow, Table } from 'semantic-ui-react'

export const SliderContainer = styled.div`
    width: 100%;
    height: min(46vw, 890px);
    position: relative;
    background: linear-gradient(to right, rgba(0, 0, 0, .8), rgba(0, 0, 0, .1));

    & .ui.grid {
        margin: 0;
        & .row {
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
        }
    }

    @media (max-width: 767px) {
        font-size: 18px;

        & .ui.stackable.grid>.row:not(:last-of-type)>.column{
            padding-bottom: 0 !important;
        }
    }
    @media (max-width: 630px) {
        height: auto;
    }
`

const CustomButton = styled(Button)`
    &.ui.inverted.secondary.basic.button {
        box-shadow: 0 0 0 2px rgba(255,255,255,.9) inset!important;
        height: fit-content;
    }
    &.ui.button {
        font-size: 1em;
        &:not(.circular) {
            padding: 0.5em 1em;
            border-radius: 0.2rem;
        }
    }
`
export const MainButton = styled(CustomButton)`
    @media (max-width: 767px) {
        &&&& {
            ${({ $hideMobile }) => $hideMobile && 'display: none;'};
        }
    }
    &.ui.primary.button {
        background-color: ${({ $color }) => $color};
        font-weight: normal;
    }
    width: ${({ $width }) => $width};
`

export const SecondaryButton = styled(CustomButton)`
    &&.ui.button {
        box-shadow: 0 0 0 1px ${({ $color }) => $color} inset!important;
        color: ${({ $color }) => $color}!important;
        /* margin-top: 22px; */
        &:hover {
            box-shadow: 0 0 0 1px ${({ $color }) => $color + '80'} inset!important;
        }
    }
`

export const SliderVideo = styled.video`
    width: 100%;
    height: min(46vw, 890px);
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    object-fit: cover;

    @media (max-width: 630px) {
        height: 100%;
        left: auto;
        width: auto;
        right: 0;
    }
`

export const TextDiv = styled.div`
    &&& {
        margin-top: 3em;
        @media (max-width: 1280px) {
            margin-top: 2em;
        }
        @media (max-width: 1070px) {
            margin-top: 1em;
        }
        @media (max-width: 767px) {
            margin-top: .5em;
        }
        * {
            color: white;
        }
    }
`

export const ContactsContainer = styled(TextDiv)`
    &>* {
        margin-right: .5em;
        display: block;
    }
    &&& a:hover {
        color: #009846;
    }
`

export const NormalHeader = styled(Header)`
    &&& {
        font-weight: normal;
        font-size: 1.7em;
        @media (max-width: 1199px) {
            font-size: 1.5em;
        }
        /* color: #fff; */
        /* margin-top: 0.5em; */
    }
`
export const SliderHeader = styled(NormalHeader)`
    &&& {
        @media (min-width: 1200px) {
            font-size: 2em;
        }
    }
`

export const InvertedButton = styled(CustomButton)`
    @media (max-width: 767px) {
        display: ${({ $hideMobile }) => $hideMobile && 'none'}!important;
    }

    &.ui.inverted.secondary.basic.button:hover {
        box-shadow:0 0 0 2px rgba(255,255,255,.5) inset!important;
        color: #fff!important;
    }
`

type NewsProjectNameProps = {
    $color: string
}

export const CustomCard = styled(Card)`
    &&& {
        font-size: 18px;
    }
    &&&>.header {
        padding: 1em 1em 0;
    }
    &&&>.content {
        border: none;
        color: rgba(0, 0, 0, 0.87);
        padding: .5em 1em;
        display: table;
        &>* {
            display: table-cell;
            vertical-align: middle;
        }
    }
`

export const NewsProjectName = styled.span<NewsProjectNameProps>`
    color: ${({ $color }) => $color};
    line-height: 1.733em;
`

export const NewsCard = styled(CustomCard)`
    &&& {
        border-radius: 1rem;
        margin: 0.2em 0.5em;

        &:first-child {
            & .circle.icon {
                color: #008000;
            }
        }
        &:not(:first-child) {
            & .circle.icon {
                color: rgba(0, 0, 0, 0.2);
            }
            box-shadow: none;
            background-color: inherit;
        }
    }

    &&&>.content {
        padding: .5em;
    }
    & .description {
        line-height: 1.2em;
        margin-left: 1.2em;
    }

    & span {
        font-size: 16px;
    }

    & .ui.grid {
        & .row {
            padding-top: .5em;
            padding-bottom: .6em;
            & .right.aligned.column span>a:not(:hover),
            & .right.aligned.column span {
                color: rgba(0,0,0,.5);
                margin-left: 0.5em;
            }
        }
        margin-right: -2em;
    }
`

export const MoreNews = styled.a`
    padding-top: 1em;
    color: rgba(0,0,0,.68);
    float: right;
    font-size: 18px;
`

export const BodyContainer = styled(Container)`
    padding: 1em;
    margin-top: 1em;
    margin-bottom: 1em;
    &>.ui.grid {
        padding-left: 1em;
    }
    @media (max-width: 767px) {
        &&&&& {
            margin-left: 0!important;
            margin-right: 0!important;
        }
        .hiddenMobile {
            display: none;
        }
    }
    @media (min-width: 768px) {
        .hiddenDesktop {
            display: none;
        }
    }
`

export const Projects = styled.div`
    position: relative;
    @media (max-width: 767px) {
        font-size: 18px;
        line-height: 1.2em;
    }
    @media (max-width: 440px) {
        font-size: 16px;
    }
    &>.ui.table {
        border: none;
    }
`
type ProjectsItemsProps = {
    $color?: string,
    $left?: any,
    $top?: any,
    $revertMobile?: boolean
}

export const ProjectsIcon = styled.div<ProjectsItemsProps>`
    position: ${({ $top, $left }) => $top || $left ? 'absolute' : 'relative'};
    font-size: 0.91em;
    top: ${({ $top }) => $top};
    left: ${({ $left }) => $left};
    margin: auto 0;
    &>a {
        display: grid;
        justify-items: center;

        &>div {
            position: relative;
        }
    }

    & img {
        width: 80px;
        height: 80px;
        transition: transform 200ms;
    }
    & a img {
        cursor: pointer;
    }
    &:hover img {
        transform: scale(1.1);
    }


    & span {
        position: absolute;
        color: ${({ $color='black' }) => $color};
        margin-top: 0.5em;
        font-size: 1em;
        text-align: center;
        transform: translateX(-50%);
        width: max-content;
        line-height: 1.2em;
    }
    @media (max-width: 1199px) {
        transform: scale(0.83) translate(-13%, -13%);
    }
    @media (max-width: 991px) {
        transform: scale(0.64) translate(-34%, -34%);
        & span {
            font-size: 1.1em;
        }
    }
    @media (max-width: 710px) {
        transform: scale(0.5) translate(-55%, -55%);
        & span {
            font-size: 1.3em;
            margin-top: .25em;
        }
    }
    @media (max-width: 542px) {
        transform: scale(0.4) translate(-80%, -80%);
        &>a {
            pointer-events: none;
        }
        & span {
            ${({ $revertMobile }) => $revertMobile && 'bottom: 0;'}
            margin-top: 0;
            width: max-content;
            font-size: 1.5em;
        }
        & img {
            order: ${({ $revertMobile }) => $revertMobile ? 1 : 0};
        }
    }
    @media (max-width: 420px) {
        transform: scale(0.35) translate(-100%, -120%);
    }
    @media (max-width: 350px) {
        transform: scale(0.3) translate(-120%, -140%);;
    }
`

export const Map = styled(Image)`
    width: 100%;
    transform: scale(0.6);
    transform-origin: top right;
    /* float: right; */
`

export const MapContainer = styled.div`
    /* height: 450px; */
    position: relative;
    /* display: flex; */
    /* justify-content: end; */
    /* background-color: rgba(225, 237, 249, .5);
    border-radius: 50% / 10%;
    padding: 1em; */

    /* &>h3 {
        display: inline-block;
        margin-top: 40px;
    } */
`
type PartnerIconProps = {
    $width?: string,
    $height?: string,
    $padding?: any
}

export const PartnerIcon = styled(ProjectsIcon)<PartnerIconProps>`
    & img {
        width: ${({ $width='100px' }) => $width};
        height: ${({ $height='100px' }) => $height};
        padding: ${({ $padding=0 }) => $padding};
        border-radius: 50%;
    }
    &:hover img {
        transform: scale(1.6);
    }
    @media (max-width: 1199px) {
        transform: scale(0.83) translate(-13%, -13%);
    }
    @media (max-width: 991px) {
        transform: scale(0.64) translate(-34%, -34%);
    }
    @media (max-width: 767px) {
        transform: scale(0.6) translate(-36%, -36%);
    }
    @media (max-width: 500px) {
        transform: scale(0.5) translate(-38%, -38%);
    }
    @media (max-width: 400px) {
        transform: scale(0.4) translate(-58%, -58%);
    }
    @media (max-width: 542px) {
        &>a {
            pointer-events: auto;
        }
        &:hover img {
            transform: scale(1.4);
        }
    }
`

export const ReviewsCardFooter = styled.div`
    padding: 0 1em 1em;
`

export const Carousel = styled.div`
    & .alice-carousel__stage-item {
        /* transition: all 200ms; */
        padding: .5em;
        height: 350px;
        cursor: pointer;
    }
    & .ui.fluid.card {
        height: 100%;
        & .content {
            /* padding: .5em; */
        }
    }
    & .alice-carousel__prev-btn {
        cursor: pointer;
        text-align: left;
        position: absolute;
        top: 145px;
        margin-left: -20px;
        width: auto;
    }
    & .alice-carousel__next-btn {
        cursor: pointer;
        text-align: right;
        position: absolute;
        top: 145px;
        right: 0;
        margin-right: -20px;
        width: auto;
        &>i{
            text-align: right;
        }
    }
    & .alice-carousel__dots {
        @media (max-width: 767px) {
            display: none;
        }
        margin-top: .5em;
    }
`

export const FullWidthBackgroundContainer = styled.div`
    position: relative;
    color: #fff;
    padding: 2em;
    background-color: #3c8e47;

    @media (min-width: 768px) {
        &>.container>.ui.grid {
            padding-left: 1rem;
        }
    }
    @media (max-width: 767px) {
        padding-left: 0;
        padding-right: 0;
    }
`

export const MainPageFullWidthBackgroundContainer = styled(FullWidthBackgroundContainer)`
    padding: .1px 0;
`

export const CertsBackgroundContainer = styled(FullWidthBackgroundContainer)`
    margin-top: 200px;

    @media (min-width: 992px) {
        padding: 2.5em 2em;
    }

    @media (max-width: 1500px) {
        margin-top: calc(45vw - 445px);
    }

    @media (max-width: 1199px) {
        margin-top: 1em;
    }

`

export const CertsImageContainer = styled.div`
    position: absolute;
    width: 50%;
    right: 50%;
    bottom: 0;
    padding: 1em;
    max-width: 700px;
    @media (max-width: 1199px) {
        top: 0;
        display: flex;
        align-items: center;
    }
    @media (max-width: 767px) {
        display: none;
    }
`

export const StatsContainer = styled(BodyContainer)`
    position: relative;
    
    @media (min-width: 768px) {
        margin-bottom: 0;
        margin-top: 0;
    }
    @media (min-width: 1200px) {
        height: max(calc(26em - 23vw), 131px);
    }
`

export const StatsComponent = styled.div`
    @media (max-width: 991px) {
        &>.ui.cards {
            margin-top: 1em;
        }
    }

    @media (min-width: 768px) {
        border-radius: 0.5em;
        background: rgba(124, 124, 124, .2);
        padding: 1em 2em;
    }

    @media (min-width: 992px) {
        margin-top: -1em;
        transform: translateY(max(calc(51% - 20vw), -234px));
        background: linear-gradient(to top, rgba(124, 124, 124, .9), rgba(255, 255, 255, .4));

        &>.ui.cards {
            transform: translateY(54%);
        }
    }
    @media (min-width: 1200px) {
        &>.ui.cards {
            transform: translateY(40%);
        }
    }
`

export const LargestInRussia = styled.div`
    @media (min-width: 992px) {
        position: absolute;
        color: #fff;
        margin: 0 .5em;
    }

    @media (max-width: 991px) {
        svg path {
            fill: initial!important;
            stroke: initial!important;
        }
    }

    * {
        line-height: 1em;
    }

    svg {
        float: left;
        margin-right: 1em;
    }
`

export const StatsCard = styled(Card)`
    &&&& {
        @media (min-width: 1200px) {
            width: calc(33.3333% - 3em);
            margin: 1.5em;
            padding: .5em;
        }

        @media (min-width: 768px) and (max-width: 991px) {
            margin-left: 0.5em;
            margin-right: 0.5em;
            width: calc(33.33333% - 1em);
        }

        line-height: 1em;
    }
`

export const StatsHeader = styled.span`
    font-size: 3em;
    line-height: 1.4em;
    @media (max-width: 991px) {
        font-size: 2em;
    }
`
export const StatsColored = styled.span`
    color:  #009846;
    @media (min-width: 768px) and (max-width: 991px) {
        &~span {
            font-size: .85em;
        }
    }
`

type SVGWrapperProps = {
    $padding?: any
}
export const SVGWrapper = styled.div<SVGWrapperProps>`
    padding: ${({ $padding }) => $padding};
    & svg {
        width: 100%;
        height: 100%;
    }
`

export const CalendarHeaderCover = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    @media (min-width: 768px) {
        /* margin: 0 1em; */
        margin-bottom: 1em;
    }
`

export const ServicesHeaderCover = styled(CalendarHeaderCover)`
    margin-bottom: 1em;
`

export const CalendarDownloadButtonsCover = styled.div`
    display: flex;
    gap: .5em;

    @media (max-width: 380px) {
        flex-direction: column;
        row-gap: 5px;
    }
`

export const Helper = styled.a`
    @media (min-width: 768px) {
        margin-left: 1em;
    }
    color: white;
    text-decoration: underline;
    cursor: pointer;
    display: inline-block;
    margin-top: .5em;

    &:hover {
        color: white;
        opacity: .5;
        text-decoration: underline;
    }
`
type MessageContainerProps = {
    $bColor?: string,
    $color?: string
}
export const MessageContainer = styled(MainPageFullWidthBackgroundContainer)<MessageContainerProps>`
    background-color: ${({ $bColor }) => $bColor};
    border-color: ${({ $bColor }) => $bColor};
    color: ${({ $color }) => $color || 'white'};
    font-size: 18px;
    line-height: 1.2em;
    margin: 0;
    border-radius: 0;
    box-shadow: none;

    .ui.container{
        padding: 0 1rem;
        &>div {
            margin-bottom: 0;

            @media (max-width: 767px) {
                img {
                    display: none !important;
                }
            }
        }
    }
    a {
        color: white;
        text-decoration: underline;
        text-underline-offset: 2px;
    }
    a:hover {
        color: white;
        opacity: .5;
    }
`
type ColorProps = {
    $color?: string
}

export const FlexDiv = styled.div`
    width: 100%;
    display: inline-flex;
    gap: .4em;
    div:first-child {
        border-top-left-radius: 3rem;
        @media (min-width: 381px) {
            border-bottom-left-radius: 3rem;
        }
    }
    div:last-child {
        border-top-right-radius: 3rem;
        border-bottom-right-radius: 3rem;
    }
`
export const HorizontalStyledDiv = styled.div<ColorProps>`
    text-align: center;
    color: white;
    background: ${({ $color }) => $color};
    padding: .5em 1em;
    flex: 1;
    display: flex;
    font-weight: 800;

    span {
        margin: auto 0;
    }
`

export const ProjectsRow = styled(TableRow)<ColorProps>`
    &&&&{
        vertical-align: top;
        &>td {
            border: none;
            padding: .2em 0;
            height: 1px;
            &:first-child {
                /* text-align: end; */
            }
        }
        @media (min-width: 381px) {
            td.two.wide {
                width: 5%;
            }
            td.seven.wide {
                width: 45%
            }
        }
    }
`

export const ProjectButton = styled(CustomButton)<ColorProps>`
    &&&&& {
        display: flex;
        align-items: center;
        text-align: left;
        position: relative;
        margin: 1em 0 .5em;
        padding: 0;
        border-radius: 2em;
        color: ${({ $color }) => $color}!important;
        box-shadow: none;
        font-weight: 800;
    }
    &>img{
        width: 3em;
    }
    &>span {
        margin-left: .5em;
    }
    @media (max-width: 380px) {
        &>img{
            display: none;
        }
    }
    &~p {
        line-height: 1.2;
    }
`

export const VerticalCenterLine = styled.div<ColorProps>`
    writing-mode: vertical-rl;
    vertical-align: middle;
    text-align: center;
    color: white;
    background: ${({ $color }) => $color};
    height: 100%;
    line-height: 1.4em;
    font-weight: 800;
    
    @media (min-width: 381px) {
        transform: translateX(-50%);
        margin-left: 50%;
    }

    &.last {
        border-bottom-left-radius: 1em;
        border-bottom-right-radius: 1em;
    }
`

export const HiddenWideMobileTable = styled(Table) `
    @media (min-width: 381px) {
        display: none;
    }
`

export const HiddenSmallMobileTable = styled(Table)`
    @media (max-width: 380px) {
        display: none;
    }
`